var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-popup',{attrs:{"options":Object.assign({}, {offset: _vm.offset,
    className: 'leaflet-custom-popup',
    offset: _vm.offset},
    _vm.options)}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }